export {
    default as Header,
    IHeaderProps,
} from './header';
